/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsListPreconfigured } from "../../funcs/llmSkillsListPreconfigured.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListPreconfiguredSkillsRequest$inboundSchema,
};

export const tool$llmSkillsListPreconfigured: ToolDefinition<typeof args> = {
  name: "llm-skills-list-preconfigured",
  description: `List preconfigured skills

Returns the list of preconfigured skills that ship with the gateway. These can be referenced in shell tool definitions as { type: 'preconfigured', name: '...' }.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsListPreconfigured(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
